<div class="search-bar" appClickOutside (clickOutside)="toggleSuggestionBox(false)">
  <input class="search-input" [formControl]="searchControl" [placeholder]="placeholder()" (focus)="toggleSuggestionBox(true)" (keyup.enter)="onSearchEnter()" />

  <div class="icon-wrapper">
    @if (searchControl.value) {
      <button class="icon-button" type="button" [attr.aria-label]="'common.action.reset' | translate" (click)="clearSearchInput()">
        <app-icon name="X" size="lg" />
      </button>
    }
    <button class="icon-button" type="button" [attr.aria-label]="'common.action.search' | translate" (click)="onSearchEnter()">
      <app-icon name="Search" size="lg" />
    </button>
  </div>

  @if (searchControl.value && isShowSuggestionBox()) {
    <div class="suggestions-box">
      @if (suggestedProducts(); as products) {
        @if (products.length) {
          @for (product of products; track product.id) {
            @if (isDesktop()) {
              <a [routerLink]="['/product', product.productNumber]" class="suggestion-item" (click)="toggleSuggestionBox(false)">
                <img [ngSrc]="product.cover?.media | smallestThumbnail" [alt]="product.cover?.media?.alt" height="45" width="45" />
                <span class="name">{{ product.name }}</span>
                <span class="article">{{ "common.dictionary.product_number" | translate }} {{ product.productNumber }}</span>
                <app-product-status [product]="product" [showShortStatus]="true" />
                <app-product-price searchbarPrice [product]="product" />
              </a>
            } @else {
              <a [routerLink]="['/product', product.productNumber]" class="suggestion-item-mobile" (click)="toggleSuggestionBox(false)">
                <img [ngSrc]="product.cover?.media | smallestThumbnail" [alt]="product.cover?.media?.alt" height="45" width="45" />
                <div class="title-wrapper">
                  <span class="name">{{ product.name }}</span>
                  <span class="article">{{ "common.dictionary.product_number" | translate }} {{ product.productNumber }}</span>
                  <app-product-status [product]="product" [showShortStatus]="true" />
                </div>
                <app-product-price searchbarPrice [product]="product" />
              </a>
            }
          }
          <button class="show-all-button" type="button" (click)="onSearchEnter()">
            {{ "common.action.show_all_results" | translate }}
            <app-icon name="ArrowRight" size="md" />
          </button>
        } @else {
          <ng-container *ngTemplateOutlet="noResultPlaceholder" />
        }
      } @else {
        <ng-container *ngTemplateOutlet="loadingPlaceholder" />
      }
    </div>
  }
</div>

<ng-template #noResultPlaceholder>
  <div class="placeholder">
    <app-icon name="SearchX" color="grey-400" size="xxl" />
    <span class="placeholder-text">{{ "common.form.template_placeholder.no_products_found" | translate }}</span>
  </div>
</ng-template>

<ng-template #loadingPlaceholder>
  <div class="placeholder">
    <app-loading-spinner [show]="true" />
    <span class="placeholder-text">{{ "common.form.template_placeholder.searching_for_products" | translate }}</span>
  </div>
</ng-template>
